<template>
  <div class="group w-full e1:m-auto e1:max-w-3xl">
    <Carousel>
      <CarouselContent>
        <CarouselItem v-for="(imgUrl, index) in imgUrls" :key="index">
          <OptimizedImage
            alt="experience-image"
            loading="lazy"
            :class="['w-full transition-all duration-500 md:group-hover:scale-[102%]']"
            :image-url="imgUrl"
            :optimized-image-options="{ width: 1280 }"
          />
        </CarouselItem>
      </CarouselContent>
      <CarouselPrevious v-if="!isSP" class="md:hidden md:group-hover:block" />
      <CarouselNext v-if="!isSP" class="md:hidden md:group-hover:block" />
      <CarouselDotIndicator class="md:hidden md:group-hover:flex" />
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import { useIsSP } from '@/composables/ui/useIsSP';
import OptimizedImage from '@/wabunka-src/common/components/stateful/OptimizedImage/OptimizedImage.vue';

interface Props {
  imgUrls: string[];
}

defineProps<Props>();

const isSP = useIsSP();
</script>
